import React, { Component } from "react";
import "../style/style.css";
import Header from "./Header";

export default class Navbar extends Component {
    constructor(props) {
        super(props);
        this.headerRef = React.createRef();
    }

    //Header hide-when scroll down and display again
    componentDidMount() {
        window.addEventListener("scroll", this.handleScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.handleScroll);
    }
    handleScroll = (event) => {
        var currentScrollPos = window.pageYOffset;

        if (currentScrollPos > 20) {
            // I am using 'display' instead of 'top':
            this.headerRef.current.style.display = "none";
        } else {
            this.headerRef.current.style.display = "flex";
        }
    };

    render() {
        return (
            <div>
                <header ref={this.headerRef} id="topHeader">
                    <div id="navPhone">
                        <a href="tel:440-282-7147">
                            {" "}
                            <i
                                className="fa fa-phone"
                                aria-hidden="true"></i>{" "}
                            440-282-7147{" "}
                        </a>
                    </div>
                    <div>
                        <a href="mailto:littlepeoplespalace@gmail.com">
                            <i
                                className="fa fa-envelope"
                                aria-hidden="true"></i>
                            littlepeoplespalace@gmail.com{" "}
                        </a>
                    </div>
                    <div className="infoPart">
                        <a
                            href="https://goo.gl/maps/RgsQJSEzK3NGUx2P6"
                            target="_blank">
                            <i className="fa fa-map" aria-hidden="true"></i>{" "}
                            3500 Beavercrest Drive, Lorain, OH 44053
                        </a>
                    </div>

                    <div>
                        <a
                            href="https://www.instagram.com/lpplorain/"
                            target="_blank">
                            {" "}
                            <i
                                className="fab fa-instagram"
                                id="headerSocial"></i>{" "}
                        </a>
                        <a
                            href="https://www.facebook.com/littlepeoplespalace1"
                            target="_blank">
                            <i
                                className="fab fa-facebook"
                                id="headerSocial"></i>
                        </a>
                        <i className="fab fa-linkedin-in" id="headerSocial"></i>
                    </div>
                </header>

                <Header />
            </div>
        );
    }
}
